import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';

import { IApplicationContext } from 'shared/types/applicationContext';
import { ApplicationContext } from 'shared/utils/applicationContext';

interface IApplicationProps {
  context: IApplicationContext;
}

export const PromoApplication: FC<React.PropsWithChildren<IApplicationProps>> = ({ context, children }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>{children}</UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
